import React, { useRef } from 'react';
import { ClockIcon } from '@heroicons/react/24/outline';

interface NativePickerInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  pickerLabel: string;
}

const NativePickerInput: React.FC<NativePickerInputProps> = ({
  pickerLabel,
  className = '',
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => {
    const input = inputRef.current;
    if (!input) return;

    try {
      if (typeof input.showPicker === 'function') {
        input.showPicker();
        return;
      }
    } catch {
      // Fall through to the platform's ordinary focused-input behavior.
    }

    input.focus();
    input.click();
  };

  return (
    <div className="relative">
      <input ref={inputRef} {...props} className={`${className} pr-12`} />
      <button
        type="button"
        aria-label={pickerLabel}
        onClick={openPicker}
        className="absolute inset-y-0 right-0 flex min-h-11 min-w-11 items-center justify-center rounded-r-md text-gray-500 hover:text-club-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-club-blue-500 dark:text-gray-300 dark:hover:text-club-blue-300"
      >
        <ClockIcon aria-hidden="true" className="h-5 w-5" />
      </button>
    </div>
  );
};

export default NativePickerInput;
